<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/accounting'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
  />
</template>
<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import {ProductService} from "../../../_services/api/products/product.service"
import { SplitViewService } from "../../../_services/api/templates/split-view.services";

export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        Code: "",
        Description: "",
        Rate: 0.0,
        WetRate: 0.0,
        Active: true,
        CreatedBy: "",
        DateCreated: "",
        ChangedBy: "",
        DateChanged: "",

        IsDefault: "Y",
        IsDefaultData: false,
        SetDefault: true,
        Inactive: true,
      },
      data: {
        title: "Tax Category",
        pageRoute: "/tax-category",
        saveEndPoint: "Tax",
        recordEndPoint: "Tax",
        updateEndPoint: "Tax",
        updateKeyField: "Code",
        updateKeyFieldType: "string",
        isDefaultEndPoint: "Save_DefaultTax",
        exportFileName: "Tax Category",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "Tax",
              filter: "",
              select: [
                "Code",
                "Description",
                "Rate",
                "WetRate",
                "Inactive",
                "IsDefault",
              ],
              sort: [{ selector: "Code", desc: false }],
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "tax-category",
              mode: "review",
              idProperty: "Code",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/tax-category/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "TaxCode",
              dataField: "Description",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "Description",
                  },
                ],
                secondary: [
                  {
                    dataField: "Code",
                  },
                ],
              },
              allowSearch: false,
              allowHiding: false,
              label: "Tax Category",
            },
            {
              screenField: "GstAmount",
              dataField: "Rate",
              label: "GST",
              format: "Decimal-6-4",
              width: 300,
            },
            {
              screenField: "GstAmount",
              dataField: "WetRate",
              label: "WET",
              format: "Decimal-6-4",
              width: 300,
            },
            {
              screenField: "Code",
              dataField: "Code",
              allowHiding: false,
              label: "Code",
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "Description",
              dataField: "Description",
              allowHiding: false,
              label: "Description",
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "IsDefault",
              makeDisabled: (data) => {
                return (
                  data.column.dataField == "IsDefault" &&
                  data.data.Inactive == "Y"
                );
              },
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: "0",
            },
          ],
          valueChangedEventListners: [
            {
              dataField: "IsDefault",
              listner: async (event, cellInfo, grid, updateIsDefault) => {
                var items = grid.getDataSource().items();
                var getDefault,
                  clickedDefault = undefined;
                if (items)
                  items.forEach((element) => {
                    if (element.Code == cellInfo.data.Code)
                      clickedDefault = element.Code;
                    if (element.IsDefault == "Y") getDefault = element.Code;
                  });
                if (!getDefault)
                  await SplitViewService.getIsDefault("Tax").then((res) => {
                    if (res.data.value.length > 0)
                      getDefault = res.data.value[0].Code;
                  });
                let confirmLeaving = await this.$confirm(
                  `Do you want to change the default setting from ${getDefault} to ${clickedDefault} ?`,
                  "Default Setting Change"
                );
                if (!confirmLeaving) {
                  event.component.beginUpdate();
                  event.component.option("value", false);
                  event.component.endUpdate();
                  return;
                }
                if (updateIsDefault) {
                  this.$store.dispatch("ui/setUpdateIsDefault", {
                    update: true,
                    code: cellInfo.data.Code,
                    event: event,
                  });
                }
              },
            },
          ],
        },
      },
    };
  },
  computed: {
    setDefaultEdit() {
      return this.formModel["IsDefaultData"] || !this.formModel["Inactive"];
    },
    setActiveReadOnly() {
      return this.formModel["SetDefault"] ? true : false;
    },
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: true,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: this.setActiveReadOnly,
                onValueChanged:(e) => {
                  this.onActiveValueChanged(e);
                },
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                screenField: "Code",
                dataField: "Code",
                editorOptions: {
                  maxLength: 2,
                },
                required: true,
                isPrimaryKeyField: true,
                label: { text: "Code" },
                visible: true,
                allowUpdate: this.baseView.mode == "create",
              },
              {
                screenField: "Code",
                dataField: "Description",
                label: { text: "Description" },
                required: true,
                allowUpdate: this.baseView.mode !== "review",
                isPrimaryKeyField: true,
              },
              {
                screenField: "Total",
                dataField: "Rate",
                label: { text: "GST Rate" },
                required: true,
                allowUpdate: this.baseView.mode !== "review",
                isPrimaryKeyField: true,
                format: "Decimal-6-4",
                defaultValue: 0,
              },
              {
                screenField: "Total",
                dataField: "WetRate",
                label: { text: "Wet Rate" },
                required: true,
                allowUpdate: this.baseView.mode !== "review",
                isPrimaryKeyField: true,
                format: "Decimal-6-4",
                defaultValue: 0,
              },
              {
                dataField: "SetDefault",
                editorOptions: {
                  readOnly: this.setDefaultEdit,
                },
                screenField: "IsDefault",
              },
            ],
          },
        ],
      };

      return form;
    },
  },
  methods: {
    async onActiveValueChanged(e) {
      if (
        this.baseView.mode == "edit" &&
        e.value == false &&
        e.previousValue == true
      ) {
        this.setLoading = true;
          ProductService.getProductData(`TaxCode eq '${this.baseView.id}'`)
          .then((res) => {
            this.setLoading = false;

            if (res.data.value.length > 0) {
              this.formModel.Inactive = true;

              e.component.beginUpdate();
              e.component.option("value", true);
              e.component.endUpdate();

              this.validationSummary = [];
              this.validationSummary.push({
                message: `${this.baseView.id} is associated with product records. This may not be marked inactive until it is no longer associated with product records.`,
              });
              this.validationSummary.push({
                message: `Tip: To identify the associated product use the filters on the product list.`,
              });
            }
          })
          .catch((err) => {
            if (err) this.setLoading = false;
          });
      }
    },
  },
};
</script>
